import React from "react";
import fullLogo from "../assets/goldenelia-full.png";

/**
 * Full Golden Elia logo — AI-rendered ultra-high-resolution gold artwork
 * (tree + "GOLDEN ELIA" wordmark + flanking branches + "GREEK TREASURE" tagline)
 * baked into a single transparent PNG. Renders crisp at any size on the
 * cinematic video background.
 */
export const FullLogo = ({
  size = 280,
  className = "",
  testid = "full-logo",
}) => {
  const widthStyle = typeof size === "number" ? `${size}px` : size;

  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center justify-center select-none ${className}`}
      style={{ width: widthStyle }}
    >
      <img
        src={fullLogo}
        alt="Golden Elia — Greek Treasure"
        draggable={false}
        className="block w-full h-auto"
        style={{
          filter:
            "drop-shadow(0 2px 0 rgba(0,0,0,0.45)) drop-shadow(0 6px 22px rgba(0,0,0,0.5))",
          imageRendering: "auto",
        }}
      />
    </div>
  );
};

export default FullLogo;
